module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst fieldConfig = model.config || {}\nconst fieldsConfig = fieldConfig.fields || {}\nconst dataJSON = model.dataJSON || {}\nconst email = dataJSON.email || ''\nconst emailConfirmed = dataJSON.emailConfirmed || ''\nconst emailConfirmedAt = dataJSON.emailConfirmedAt || ''\nconst emailConfirmationSentAt = dataJSON.emailConfirmationSentAt || ''\nconst additionalClasses = []\nconst fieldClasses = []\nconst status = {\nsymbol: '',\nmessage: ''\n}\nif(email){\nif(emailConfirmedAt){\nstatus.symbol = 'fi fi-check-double'\n} else if(emailConfirmationSentAt) {\nstatus.symbol = 'fi fi-check'\nstatus.message = storage.__('form.fields.emailConfirmation.missingConfirmation')\n} else {\nstatus.symbol = 'fi fi-exclamation-triangle'\nstatus.message = storage.__('form.fields.emailConfirmation.missingConfirmationMail')\n}\n}\n%><div class=\"<%- additionalClasses.join(' ') %>\">\n<div class=\"data\">\n<div class=\"confirmation\">\n<%\nif(emailConfirmedAt){\nconst m = utils.moment(emailConfirmedAt)\n%><%- storage.__('form.fields.emailConfirmation.confirmedAt', { date: m.format('DD.MM.YYYY'), time: m.format('HH:mm') }) %><%\n} else if(emailConfirmationSentAt){\nconst m = utils.moment(emailConfirmationSentAt)\n%><%- storage.__('form.fields.emailConfirmation.sentAt', { date: m.format('DD.MM.YYYY'), time: m.format('HH:mm') }) %><%\n}\n%>\n</div>\n<input data-field-type=\"text\" type=\"text\" value=\"<%= email %>\"<%- (model.disabled ? 'disabled=\"disabled\"' : ''); %> placeholder=\"<%= model.placeholder || '' %>\" class=\"<%= fieldClasses.join(' ') %>\"/>\n<%\nif(status.symbol){\n%><i class=\"<%- status.symbol %>\" title=\"<%= status.message %>\"></i><%\n}\n%>\n</div>\n<div class=\"controls\">\n<%\nif(!emailConfirmed && !(fieldsConfig.sendConfirmation || {}).disabled){\nlet additionalSymbol\nif(model.sendEmailConfirmation){\nadditionalSymbol = 'fi fi-send-confirmation'\n}\n// TODO: no fieldConfig available in default buttons?!\nconst disabled = emailConfirmed || (fieldsConfig.sendConfirmation || {}).disabled\n%><%- include('../elements/buttons/default', { formMapping: { buttonType: 'sendConfirmation', context: 'email', mode: 'mail', symbolOnly: true, fieldConfig: { disabled }, additionalSymbol, preventTabIndex: true } }); %><%\n}\n%>\n</div>\n</div>"
  , __filename = "..\\frontend-controller\\baseComponents\\form\\fields\\confirmedMail.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const fieldConfig = model.config || {}
const fieldsConfig = fieldConfig.fields || {}
const dataJSON = model.dataJSON || {}
const email = dataJSON.email || ''
const emailConfirmed = dataJSON.emailConfirmed || ''
const emailConfirmedAt = dataJSON.emailConfirmedAt || ''
const emailConfirmationSentAt = dataJSON.emailConfirmationSentAt || ''
const additionalClasses = []
const fieldClasses = []
const status = {
symbol: '',
message: ''
}
if(email){
if(emailConfirmedAt){
status.symbol = 'fi fi-check-double'
} else if(emailConfirmationSentAt) {
status.symbol = 'fi fi-check'
status.message = storage.__('form.fields.emailConfirmation.missingConfirmation')
} else {
status.symbol = 'fi fi-exclamation-triangle'
status.message = storage.__('form.fields.emailConfirmation.missingConfirmationMail')
}
}

    ; __line = 26
    ; __append("<div class=\"")
    ; __append( additionalClasses.join(' ') )
    ; __append("\">\n<div class=\"data\">\n<div class=\"confirmation\">\n")
    ; __line = 29
    ; 
if(emailConfirmedAt){
const m = utils.moment(emailConfirmedAt)

    ; __line = 32
    ; __append( storage.__('form.fields.emailConfirmation.confirmedAt', { date: m.format('DD.MM.YYYY'), time: m.format('HH:mm') }) )
    ; 
} else if(emailConfirmationSentAt){
const m = utils.moment(emailConfirmationSentAt)

    ; __line = 35
    ; __append( storage.__('form.fields.emailConfirmation.sentAt', { date: m.format('DD.MM.YYYY'), time: m.format('HH:mm') }) )
    ; 
}

    ; __line = 37
    ; __append("\n</div>\n<input data-field-type=\"text\" type=\"text\" value=\"")
    ; __line = 39
    ; __append(escapeFn( email ))
    ; __append("\"")
    ; __append( (model.disabled ? 'disabled="disabled"' : '') )
    ; __append(" placeholder=\"")
    ; __append(escapeFn( model.placeholder || '' ))
    ; __append("\" class=\"")
    ; __append(escapeFn( fieldClasses.join(' ') ))
    ; __append("\"/>\n")
    ; __line = 40
    ; 
if(status.symbol){

    ; __line = 42
    ; __append("<i class=\"")
    ; __append( status.symbol )
    ; __append("\" title=\"")
    ; __append(escapeFn( status.message ))
    ; __append("\"></i>")
    ; 
}

    ; __line = 44
    ; __append("\n</div>\n<div class=\"controls\">\n")
    ; __line = 47
    ; 
if(!emailConfirmed && !(fieldsConfig.sendConfirmation || {}).disabled){
let additionalSymbol
if(model.sendEmailConfirmation){
additionalSymbol = 'fi fi-send-confirmation'
}
// TODO: no fieldConfig available in default buttons?!
const disabled = emailConfirmed || (fieldsConfig.sendConfirmation || {}).disabled

    ; __line = 55
    ; __append( include('../elements/buttons/default', { formMapping: { buttonType: 'sendConfirmation', context: 'email', mode: 'mail', symbolOnly: true, fieldConfig: { disabled }, additionalSymbol, preventTabIndex: true } }) )
    ; 
}

    ; __line = 57
    ; __append("\n</div>\n</div>")
    ; __line = 59
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\form\fields\confirmedMail.ejs

}